<template>
    <div>
        <form class="form-horizontal" style="margin-left: 5px;">
            <div style="display: flex;justify-content: center;margin-top: 8px;">
                <button type="button" @click="showNewCategory" class="btn btn-sm mb5 btn-primary"
                    style="padding: 0.2rem;">New Category</button>
            </div>
            <div v-if="isShow" class="d-flex flex-row border p-2 mt-2 mb-2 category-edit">
                <label class="col-form-label mr-2 label-cs">{{ isNew ? "Category (New):" :
                    "Category (Edit):"
                    }}</label>
                <input type="text" class="form-control txt-fmt" v-model="editCategoryMasterData.category_name" />
                <div class="d-flex align-items-center mr-2 ml-2">
                    <button type="button" @click="submitCategoryMasterData"
                        class="btn btn-sm btn-primary">Submit</button>
                </div>
            </div>
            <hr style="height:2px;border-width:0;color:gray;background-color:gray" />
            <div class="card-body pt-0">
                <label>Category Add/Edit:</label>
                <div class="d-flex justify-content-center" v-if="categoryMasterData.length === 0">No Data Found</div>
                <div class="d-flex justify-content-start" v-for="(field, index) in categoryMasterData"
                    v-bind:key="'row' + index">
                    <div class="col-md-6 pr-2 pl-0">
                        <div class="form-group text-end d-flex align-items-center mr-3">
                            <input type="text" class="form-control txt-fmt" v-model="field.category_name" readonly />
                            <div class="d-flex align-items-center pl-1">
                                <a class="btn btn-sm btn-small btn-primary"
                                    @click.prevent="editCategoryMasterDataClick(field)">
                                    <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                                </a>
                                <a class="btn btn-sm btn-small btn-danger" @click="removeCategoryMasterData(field)"
                                    style="margin: 4px;"><i title="Delete Row" class="fa fa-trash cwhite"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import http from "@/lib/http";
//import DeleteConfirm from "@/components/Delete-Confirm.vue";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
    props: ["getUrl", "createUpdateUrl", "deleteUrl", "curTab"],
    //components: { DeleteConfirm },
    mixins: [commonMixins],
    name: "CategoryCompo",
    created() {
        /* console.log('created >>>', this.curTab);
        console.log('----------created-------')
        console.log("getUrl         :::", this.getUrl);
        console.log("createUpdateUrl:::", this.createUpdateUrl);
        console.log("deleteUrl      :::", this.deleteUrl);
        console.log("curTab         :::", this.curTab);
        console.log('----------created-------') */
        this.getCategoryMasterData();
    },
    watch: {
        getUrl(value) {
            //console.log("getUrl:::", value);
            this.cGetUrl = String(value);
        },
        createUpdateUrl(value) {
            //console.log("createUpdateUrl:::", value);
            this.cCreateUpdateUrl = String(value);
        },
        deleteUrl(value) {
            //console.log("deleteUrl:::", value);
            this.cDeleteUrl = String(value);
        },
        curTab(value) {
            //console.log("curTab:::", value);
            if (this.cCurTab !== value) {
                this.getCategoryMasterData();
            }
            this.cCurTab = String(value);
        },
    },
    data() {
        return {
            cGetUrl: this.getUrl,
            cCreateUpdateUrl: this.createUpdateUrl,
            cDeleteUrl: this.deleteUrl,
            cCurTab: this.curTab,
            selIndex: 0,
            showDelDialog: false,
            isNew: false,
            isShow: false,
            editCategoryMasterData: { "category_name": "" },
            categoryMasterData: [],
            errors: [],
        };
    },
    methods: {
        getCategoryMasterData() {
            let self = this;
            //console.log('self.cGetUrl >>>>', self.cGetUrl, self.cGetUrl.length);
            if (self.cGetUrl.length > 0) {
                http.get(self.cGetUrl, {}, (error, response) => {
                    //console.log('getCategoryMasterData:', response)
                    if (response.status === 'success') {
                        self.categoryMasterData = response.data;
                    }
                });
            }
        },
        submitCategoryMasterData() {
            let self = this;
            if (this.editCategoryMasterData.category_name.trim() === "") {
                this.$toastr.error("Category string not blank", "", {});
            } else {
                http.post(self.cCreateUpdateUrl, this.editCategoryMasterData, function (error, response) {
                    //console.log(">>>> post data:", response);
                    if (response.responseType === "success") {
                        self.$toastr.success(response.msg, "", {});
                        self.getCategoryMasterData();
                    }
                    self.editCategoryMasterData = { category_name: "" };
                    self.isNew = false;
                    self.isShow = false;
                });
            }
        },
        removeCategoryMasterData(field) {
            let self = this;
            if (confirm("Are you sure you want to delete this item?") == true) {
                const param = { "_id": field._id };
                //console.log('param', param);
                http.post(self.cDeleteUrl, param, function (error, response) {
                    console.log('strategy/delete: ', response);
                    if (response.responseType === 'success') {
                        self.$toastr.success(response.msg, "", {});
                        self.getCategoryMasterData();
                    }
                });
            }
        },

        showNewCategory() {
            this.editCategoryMasterData = { "category_name": "" };
            this.isNew = true;
            this.isShow = true;
        },

        editCategoryMasterDataClick(param) {
            this.editCategoryMasterData = param;
            this.isNew = false;
            this.isShow = true;
            console.log("editQuery param", param);
        },
    },
};
</script>
<style scoped>
.category-edit {
    background-color: #d3ebef;
    border-radius: 5px;
    margin: 1rem;
}

.label-cs {
    min-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/views/partners/CategoryCompo.vue